import type AhaEditorV2Controller from '../../controllers/AhaEditorV2Controller';
import type Tool from '../../tools/Tool';
import React from 'react';
import ToolButton from './ToolButton';
import { type Editor } from 'slate';

const ToolbarItem = ({
  editor,
  controller,
  tool,
}: {
  editor: Editor;
  controller: AhaEditorV2Controller;
  tool: typeof Tool;
}) => {
  if (tool.toolbarSubmenu) {
    const ToolbarSubmenu = tool.toolbarSubmenu();
    return (
      <ToolbarSubmenu
        editor={editor}
        controller={controller}
        tool={tool}
        isSubmenu={false}
      />
    );
  } else {
    return <ToolButton editor={editor} controller={controller} tool={tool} />;
  }
};

export default ToolbarItem;
